import React, { useCallback, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import { Link } from "react-router-dom";

import { loadTemplateFile } from '../tools/layout-tool';
import { useAuth } from "../use-auth"

import { promiseFetchDataAuth } from 'crk-front-lib';
import { assignDotKeyValue } from 'crk-lib-tool/tools/data-util';
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { ZetaGroup, ZetaSection } from "../zeta-widget";
import { TextInput } from "../zeta-widget/widgets/text-input";
import { StaticSelect } from "../zeta-widget/widgets/zeta-select";

export function UserManage(props) {
  const auth = useAuth();
  const urlAddUser = `${auth.config.storeApi}/api/v2/users/${auth.config.appId}`;
  const urlRemoveUser = `${auth.config.storeApi}/api/v2/users/${auth.config.appId}/${auth.user.org_id}`;
  const urlValidate = `${auth.config.storeApi}/api/v2/users/validate`;

  // console.info(auth.user);
  // const [lang, setLang] = useState(auth.lang || 'en');
  const [appTemplate, setAppTemplate] = useState([]);
  const [search, setSearch] = useState({
    reqestQuery: true,
    found: []
  });

  const _selectRole = {
    label: 'Role',
    floating: false,
    name: 'role',
    // field: 'role',
    options: [
      {value:'USER', text:'User'},
      {value:'ADMIN', text:'Administrator'}
    ]
  }
  
  useEffect(() => {
    loadTemplateFile('user-manage', (result) => {
      setAppTemplate(result);
    })
  },[]);

  useEffect(() => {
    if (!search.reqestQuery) return; // Prevent infinity loop

    const url = `${auth.config.storeApi}/api/v2/users/${auth.config.appId}/${auth.user.org_id}`
    promiseFetchDataAuth(url)
    .then(result => {
      const _found = [...result];
      _found.forEach((t, i) => {
        assignDotKeyValue(_found[i], ['profile.email', 'profile.fullname']);
      })
      const _search = {...search, reqestQuery: false, found: _found};
      setSearch(_search);
    })
    .catch((err) => {
      console.warn(err);
    })
  }, [auth.config.appId, auth.config.storeApi, auth.user.org_id, auth.user.pkg_id, search])

  const handleValidate = useCallback(
    (e) => {
      promiseFetchDataAuth(urlValidate, 'POST', { email: e.target.value })
      .then(result => {
        console.info(result)
        document.querySelector('input[name=fullname]').value = result.fullname;
      })
      .catch((err) => {
        console.warn(err);
        document.querySelector('input[name=fullname]').value = '';
        showAlert('Email ไม่ถูกต้อง กรุณาตรวจสอบ', 'danger')
      })  
    },
    [urlValidate],
  )

  const performAdd = useCallback((member_id, role) => {
    const _data = {
      org_id : auth.user.org_id,
      member_id,
      member_role: role
    }
    promiseFetchDataAuth(`${urlAddUser}`, 'POST', _data)
    .then(result => {
      console.info(result);
      const _search = {...search}
      _search.reqestQuery = true;
      setSearch(_search);
    })
    .catch(err => {
      console.warn(err);
      if (err.match(/duplicate/i)) {
        showAlert('ผู้ใช้งานซ้ำ กรุณาตรวจสอบ', 'danger');
      } else {
        showAlert(err, 'danger');
      }
    })
  }, [auth.user.org_id, search, urlAddUser]);

  const handleAdd = useCallback(
    () => {
      const formdata = new FormData(document.getElementById('userform'));
      if (formdata.get('email').trim().length === 0) {
        showAlert('กรุณาป้อน email ให้ถูกต้อง', 'danger', true);
        return;
      }

      if (formdata.get('role') === '') {
        showAlert('กรุณาป้อนเลือก Role', 'danger', true);
        return;
      }

      promiseFetchDataAuth(urlValidate, 'POST', { email: formdata.get('email') })
      .then(result => {
        console.info(result);
        document.querySelector('input[name=fullname]').value = result.fullname;

        performAdd(result._id, formdata.get('role'));
      })
      .catch((err) => {
        console.warn(err);
        showAlert('Email ไม่ถูกต้อง กรุณาตรวจสอบ', 'danger');
      })
    },
    [performAdd, urlValidate],
  )

  const handleRemoveUser = useCallback(
    (idx) => {
      if (search.found[idx].member_role && search.found[idx].member_role.match(/OWNER/i)) {
        showAlert('ไม่อนุญาตให้ลบ Owner ของบริษัท', 'warning');
        return;
      }
      
      promiseFetchDataAuth(`${urlRemoveUser}/${search.found[idx].member_id}`, 'DELETE')
      .then(result => {
        console.info(result);
        if (result.member_id && result.member_id === search.found[idx].member_id) {
          const _search = {...search};
          _search.found = _search.found.filter((x, i) => i !== idx);
          setSearch(_search);
        } else {
          showAlert('เกิดความผิดพลาดในการลบข้อมูล');
        }
      })
      .catch(err => {
        console.warn(err);
      })
    },
    [search, urlRemoveUser],
  )

  const handlers = {
    handleRemoveUser
  }

  const _this = {
    auth,
    lang: auth.lang || 'en',
    locale: auth.lang === 'th'? 'th-TH': 'en-UK',

    handlers,
  };

  return (
    <ZetaSection title="รายชื่อผู้ใช้งาน" name="entry" app={_this}>
      {auth.user.member_role && auth.user.member_role==='OWNER' && 
      <React.Fragment>
        <ZetaGroup template={appTemplate} 
          data={search} app={_this} /*onChange={handleChange}*/ 
        />
      <hr />
      <p>คุณสามารถเพิ่มชื่อผู้ใช้งานโดยป้อนข้อมูลด้านล่างนี้</p>
      <form id="userform">
        <ZetaGroup size="half">
          <TextInput em={{label: "Email", floating: false, name:'email' }} onBlur={handleValidate} />
          <TextInput em={{label: "Name", floating: false, name:'fullname', readOnly:true}} />
          <StaticSelect em={_selectRole} />
          <button type="button" 
            className="btn btn-sm btn-success"
            onClick={handleAdd}
          >เพิ่มชื่อ</button>
        </ZetaGroup>
      </form>
      <br />
      <p>อนุญาตให้เพิ่มผู้ใช้งาน หลังจากที่การสมัครได้รับการอนุมัติแล้ว เท่านั้น</p>
      <p>และ ไม่อนุญาตให้ เพิ่มผู้ใช้งานเกินที่สมัครไว้</p>
      </React.Fragment>}
      {auth.user.member_role!=='OWNER' && <p>
        คุณไม่มีสิทธิ์ทำรายการในหน้าจอนี้
        </p>}
    </ZetaSection>
  )
}